
import {Box, Stack, TableCell, TableRow, Tooltip, Typography} from "@mui/material";
import {Icon} from "@iconify/react";
import {useState} from "react";
import SolicitationTaskDetailDialog from "./SolicitationTaskDetailDialog";
import {ActivityFields, ActivitySolicitation} from "../../../../types/activity/activityData";
import {dateFormatter} from "../../../../utils/formatters";
import {getActivityStatusColor} from "../../../../utils/colors/activityColors";
import IconButton from "@mui/material/IconButton";
import SearchIcon from "@mui/icons-material/Search";
import ArticleIcon from "@mui/icons-material/Article";
import {EntityWithIdFields} from "../../../../types/baseEntities";
import SolicitationTaskFilesDialog from "./SolicitationTaskFilesDialog";
import {ActivityStatus} from "../../../../types/activity/activityEnums";


interface SolicitationTaskDetailProps {
    task: ActivitySolicitation,
    solicitationId: number,
    onReload : () => void
}


const SolicitationTaskDetail = ({task, solicitationId, onReload}: SolicitationTaskDetailProps) => {
    const [openDetail, setOpenDetail] = useState<boolean>(false)
    const [openFiles, setOpenFiles] = useState<boolean>(false)
    const colorStatus : string = getActivityStatusColor(task[ActivityFields.ActivityStateCode])
    
    const handleClose = () => setOpenDetail(false)
    
    return (
        <>
            <TableRow key={task[ActivityFields.Reference]} sx={{
                '&:last-of-type td': { border: 0, pb: 0 },
                '& .MuiTableCell-root': {
                    '&:last-of-type': { pr: 0 },
                    '&:first-of-type': { pl: 0 },
                    py: theme => `${theme.spacing(2.75)} !important`
                },
                '&:first-of-type td': { borderTop: theme => `1px solid ${theme.palette.divider}` }
            }}
            >
                <TableCell>
                    <Box
                        sx={{ display: 'flex', alignItems: 'center', '& svg': { mr: 1.8, color: `${colorStatus}` } }}
                    >
                        <Icon icon='mdi:circle' fontSize='1rem' />
                        <Typography fontWeight={600}>{task[ActivityFields.ActivityStateDesc]}</Typography>
                    </Box>
                </TableCell>
                <TableCell>
                    <Typography fontWeight={500}>{`# ${task[EntityWithIdFields.Id]}`}</Typography>
                </TableCell>
                <TableCell>
                    <Typography fontWeight={500}>{task[ActivityFields.Reference]}</Typography>
                </TableCell>
                <TableCell>
                    <Typography fontWeight={500}>{dateFormatter.toShortDate(task[ActivityFields.ActivityDate])}</Typography>
                </TableCell>
                <TableCell>
                    <Typography fontWeight={500}>{dateFormatter.toShortDate(task[ActivityFields.StateDate])}</Typography>
                </TableCell>
                <TableCell>
                    <Stack direction='row' alignItems='center' spacing={2}>
                        <Tooltip title={'Ver tarea'}>
                            <IconButton onClick={() => {setOpenDetail(true)}}>
                                <SearchIcon />
                            </IconButton>
                        </Tooltip>
                        <Tooltip title={'Ver documentación anexada'}>
                            <IconButton onClick={() => {setOpenFiles(true)}}>
                                <ArticleIcon />
                            </IconButton>
                        </Tooltip>
                    </Stack>
                </TableCell>
            </TableRow>
            <SolicitationTaskDetailDialog task={task}
                                          open={openDetail}
                                          onClose={handleClose}
                                          solicitationId={solicitationId}
                                          onReload={onReload}
            />
            <SolicitationTaskFilesDialog taskId={task[EntityWithIdFields.Id]}
                                         open={openFiles}
                                         onClose={() => {setOpenFiles(false)}}
                                         taskPendant={task[ActivityFields.ActivityStateCode] == ActivityStatus.ConSeguimiento_Pendiente || task[ActivityFields.ActivityStateCode] == ActivityStatus.ConSeguimiento_EnCurso}
            />
        </>
    )
}


export default SolicitationTaskDetail